import config from '../config';

export default {
  productsIndexUrl: config.routes.productsUrl,
  productShowUrl: config.routes.productUrl,
  allTreeTaxonsIndexUrl: config.routes.allTreeTaxonsUrl,
  propertiesIndexUrl: config.routes.propertiesUrl,
  propertiesValuesIndexUrl: config.routes.propertiesValuesUrl,
  optionsIndexUrl: config.routes.optionsUrl,
  optionsValuesIndexUrl: config.routes.optionsValuesUrl,
};
